<template>
  <div>
    <Modal
      contentWidth="90%"
      :required=true
      @close="$store.commit('setOpenModalName', null)"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          SELECCIONAR MOTOR
        </p>
      </template>
      <template #body>
        <b-row v-if="!loading" align-h="around" class="mt-4">
          <b-col cols="11">
            <div class="d-flex flex-wrap align-content-center justify-content-center" style="gap: 10px;">
              <MotorSelectorScorecard
                v-for="motor in motors"
                :motor="motor"
                :key="motor.id"
                :weightEndValue="weightEndValue"
                :lengthEndValue="lengthEndValue"
                :cyclesEndValue="cyclesEndValue"
                :class="{ active: selectedMotor && motor.id == selectedMotor.id }"
                @motor-clicked="selectMotor(motor)"
              />
            </div>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>

    <!-- ConfirmModal -->
    <ConfirmModal v-if="modalShow" :required=true @close="onModalHide" @onConfirm="updateMotor">
      <template #header>
        <p class="mb-0 pb-0">Confirmar selección</p>
      </template>
      <template #body>
        <p class="fs-5 font-weight-bold mb-2">¿Seleccionar motor {{ selectedMotor.item_code }}?</p>
        <div class="selected-motor-image-container">
          <b-img :src="selectedMotorImage" class="motor-image" />
        </div>
        <p class="font-weight-bold small mb-0 mt-2">Descripción</p>
        <div class="motor-description-scroll">
          <p v-if="selectedMotor.description" class="text-muted small motor-description-text">{{ selectedMotor.description }}</p>
          <p v-else class="text-muted small motor-description-text text-center">Sin descripción</p>
        </div>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MotorSelectorScorecard from './MotorSelectorCard.vue'
import Button from '../../../shared/Button'
import ConfirmModal from '../../../shared/ConfirmModal'
import Modal from '../../../shared/Modal'

export default {
  name: 'MotorSelector',
  components: { Button, MotorSelectorScorecard, ConfirmModal, Modal },
  data () {
    return {
      motors: [],
      modalShow: false,
      weightEndValue: null,
      lengthEndValue: null,
      cyclesEndValue: null,
      selectedMotor: null,
      loading: false,
      processing: false,
      missingImg: '/images/original/missing.png'
    }
  },
  computed: {
    ...mapState ({ submital: state => state.configurator.submital }),
    ...mapGetters (['configurableId', 'configurableType', 'configurableTypeUrlString']),
    selectedMotorImage () {
      return this.selectedMotor && this.selectedMotor.cover_sample_url ? this.selectedMotor.cover_sample_url : this.missingImg
    }
  },
  mounted () {
    this.loading = true
    this.fetchMotors()
  },
  methods: {
    fetchMotors () {
      this.$http.get(`/api/production/submitals/${this.submital.id}/motors`)
        .then((res) => {
          // console.log(res.data)
          this.motors = res.data.motors
          this.weightEndValue = res.data.max_weight
          this.lengthEndValue = res.data.max_length
          this.cyclesEndValue = res.data.max_cycles
          this.loading = false
        })
        .catch(e => console.log(e))
    },
    selectMotor (motor) {
      this.selectedMotor = motor
      this.modalShow = true
    },
    onModalHide () {
      this.modalShow = false
      this.selectedMotor = null
    },
    updateMotor () {
      if (this.processing) { return }
      this.processing = true
      this.$http.patch(`/api/production/submitals/${this.submital.id}/${this.configurableTypeUrlString}/${this.configurableId}`, {
        [this.configurableType.toLowerCase()]: {
          motor_id: this.selectedMotor.id
        }
      })
        .then((res) => {
          // console.log(res.data)
          this.$store.commit('setConfigurable', res.data)
          this.$store.commit('setOpenModalName', null)
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    },
    closeModal () {
      this.modalShow = false
      this.selectedMotor = null
    }
  }
}
</script>

<style scoped>
.selected-motor-image-container {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #f8f9fa;
}

.motor-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.motor-description-scroll {
  max-height: 150px;
  overflow-y: auto;
  border-top: 1px solid #e9ecef;
  padding-top: 0.75rem;
}

.motor-description-text {
  text-align: justify;
  line-height: 1.5;
}

</style>